// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"0b46613b","404":"0b46613b","572":"9853c586","728":"0b46613b","962":"0b46613b"}[chunkId] + ".chunk.css";
};